import { parseCurrency } from '@utils/currency.util';

import {
  ProductFormData,
  ProductPayload,
} from '../interfaces/productInterface';

export function formProductFactory(formData: ProductFormData): ProductPayload {
  const warranty = Number(String(formData.warrantyDays).replace(/\D/g, ''));
  const categories = formData.categories
    .map(categoryId => Number(categoryId))
    .filter(categoryId => !isNaN(categoryId));

  if (isNaN(warranty)) {
    throw new Error('Garantia em dias deve ser um número válido');
  }

  // Transform offers array
  const offers = formData.offers.map((offer, index) => {
    const fullPrice = parseCurrency(offer.fullPrice);

    if (!fullPrice) {
      throw new Error('Valor da oferta deve ser um número válido');
    }

    return {
      fullPrice,
      acquisitionId: Number(offer.acquisitionId),
      seasonalityId: Number(offer.seasonalityId),
      typeId: Number(offer.typeId),
      isFallbackOffer: index === 0,
    };
  });

  const payload: ProductPayload = {
    name: String(formData.name).trim(),
    profileId: Number(formData.releaseProfileId),
    providerId: Number(formData.providerId),
    isDirectFallback: formData.isOnlyFallback || false,
    subscriptionType: formData.isMonthly ? 'monthly' : 'yearly',
    warranty,
    offers,
    categories,
    isPrincipal: formData.isPrincipal || false,
  };

  return payload;
}
